import { useFeatureFlags } from '@usap/core';

const useIsChatEnabled = () => {
  const { f55 } = useFeatureFlags();

  const f55Enabled = ['b', '1', 'on', 'true'];

  if (typeof f55 === 'string') {
    if (f55Enabled.includes(f55)) {
      return true;
    }
  }

  return false;
};

export default useIsChatEnabled;